import * as React from "react";
import Svg, { G, Path, Circle, Defs, ClipPath } from "react-native-svg";

function SvgComponent() {
  return (
    <Svg
      width={360}
      height={640}
      viewBox="0 0 360 640"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#prefix__clip0)">
        <Circle cx={180} cy={320} r={39.5} stroke="#000" strokeOpacity={0.2} />
        <Path
          d="M220 320a40.001 40.001 0 00-40-40v.986a39.007 39.007 0 0127.587 11.427A39.006 39.006 0 01219.014 320H220z"
          fill="#E40046"
        />
      </G>
      <Defs>
        <ClipPath id="prefix__clip0">
          <Path fill="#fff" d="M0 0h360v640H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
